/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntAttributeDTO } from './IntAttributeDTO';
import {
    IntAttributeDTOFromJSON,
    IntAttributeDTOFromJSONTyped,
    IntAttributeDTOToJSON,
} from './IntAttributeDTO';
import type { FloatAttributeDTO } from './FloatAttributeDTO';
import {
    FloatAttributeDTOFromJSON,
    FloatAttributeDTOFromJSONTyped,
    FloatAttributeDTOToJSON,
} from './FloatAttributeDTO';
import type { FileRefSeriesAttributeDTO } from './FileRefSeriesAttributeDTO';
import {
    FileRefSeriesAttributeDTOFromJSON,
    FileRefSeriesAttributeDTOFromJSONTyped,
    FileRefSeriesAttributeDTOToJSON,
} from './FileRefSeriesAttributeDTO';
import type { FileRefAttributeDTO } from './FileRefAttributeDTO';
import {
    FileRefAttributeDTOFromJSON,
    FileRefAttributeDTOFromJSONTyped,
    FileRefAttributeDTOToJSON,
} from './FileRefAttributeDTO';
import type { DatetimeAttributeDTO } from './DatetimeAttributeDTO';
import {
    DatetimeAttributeDTOFromJSON,
    DatetimeAttributeDTOFromJSONTyped,
    DatetimeAttributeDTOToJSON,
} from './DatetimeAttributeDTO';
import type { HistogramSeriesAttributeDTO } from './HistogramSeriesAttributeDTO';
import {
    HistogramSeriesAttributeDTOFromJSON,
    HistogramSeriesAttributeDTOFromJSONTyped,
    HistogramSeriesAttributeDTOToJSON,
} from './HistogramSeriesAttributeDTO';
import type { EvaluationSeriesAttributeDTO } from './EvaluationSeriesAttributeDTO';
import {
    EvaluationSeriesAttributeDTOFromJSON,
    EvaluationSeriesAttributeDTOFromJSONTyped,
    EvaluationSeriesAttributeDTOToJSON,
} from './EvaluationSeriesAttributeDTO';
import type { BoolAttributeDTO } from './BoolAttributeDTO';
import {
    BoolAttributeDTOFromJSON,
    BoolAttributeDTOFromJSONTyped,
    BoolAttributeDTOToJSON,
} from './BoolAttributeDTO';
import type { FloatSeriesAttributeDTO } from './FloatSeriesAttributeDTO';
import {
    FloatSeriesAttributeDTOFromJSON,
    FloatSeriesAttributeDTOFromJSONTyped,
    FloatSeriesAttributeDTOToJSON,
} from './FloatSeriesAttributeDTO';
import type { StringSetAttributeDTO } from './StringSetAttributeDTO';
import {
    StringSetAttributeDTOFromJSON,
    StringSetAttributeDTOFromJSONTyped,
    StringSetAttributeDTOToJSON,
} from './StringSetAttributeDTO';
import type { ExperimentStateAttributeDTO } from './ExperimentStateAttributeDTO';
import {
    ExperimentStateAttributeDTOFromJSON,
    ExperimentStateAttributeDTOFromJSONTyped,
    ExperimentStateAttributeDTOToJSON,
} from './ExperimentStateAttributeDTO';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';
import type { GitInfoDTO } from './GitInfoDTO';
import {
    GitInfoDTOFromJSON,
    GitInfoDTOFromJSONTyped,
    GitInfoDTOToJSON,
} from './GitInfoDTO';
import type { StringAttributeDTO } from './StringAttributeDTO';
import {
    StringAttributeDTOFromJSON,
    StringAttributeDTOFromJSONTyped,
    StringAttributeDTOToJSON,
} from './StringAttributeDTO';
import type { StringSeriesAttributeDTO } from './StringSeriesAttributeDTO';
import {
    StringSeriesAttributeDTOFromJSON,
    StringSeriesAttributeDTOFromJSONTyped,
    StringSeriesAttributeDTOToJSON,
} from './StringSeriesAttributeDTO';
import type { ComplexAttributeDTO } from './ComplexAttributeDTO';
import {
    ComplexAttributeDTOFromJSON,
    ComplexAttributeDTOFromJSONTyped,
    ComplexAttributeDTOToJSON,
} from './ComplexAttributeDTO';

/**
 * 
 * @export
 * @interface AttributeDTO
 */
export interface AttributeDTO {
    /**
     * 
     * @type {BoolAttributeDTO}
     * @memberof AttributeDTO
     */
    boolProperties?: BoolAttributeDTO;
    /**
     * 
     * @type {ComplexAttributeDTO}
     * @memberof AttributeDTO
     */
    complexProperties?: ComplexAttributeDTO;
    /**
     * 
     * @type {DatetimeAttributeDTO}
     * @memberof AttributeDTO
     */
    datetimeProperties?: DatetimeAttributeDTO;
    /**
     * 
     * @type {EvaluationSeriesAttributeDTO}
     * @memberof AttributeDTO
     */
    evaluationSeriesProperties?: EvaluationSeriesAttributeDTO;
    /**
     * 
     * @type {ExperimentStateAttributeDTO}
     * @memberof AttributeDTO
     */
    experimentStateProperties?: ExperimentStateAttributeDTO;
    /**
     * 
     * @type {FileRefAttributeDTO}
     * @memberof AttributeDTO
     */
    fileRefProperties?: FileRefAttributeDTO;
    /**
     * 
     * @type {FileRefSeriesAttributeDTO}
     * @memberof AttributeDTO
     */
    fileRefSeriesProperties?: FileRefSeriesAttributeDTO;
    /**
     * 
     * @type {FloatAttributeDTO}
     * @memberof AttributeDTO
     */
    floatProperties?: FloatAttributeDTO;
    /**
     * 
     * @type {FloatSeriesAttributeDTO}
     * @memberof AttributeDTO
     */
    floatSeriesProperties?: FloatSeriesAttributeDTO;
    /**
     * 
     * @type {GitInfoDTO}
     * @memberof AttributeDTO
     */
    gitRefProperties?: GitInfoDTO;
    /**
     * 
     * @type {HistogramSeriesAttributeDTO}
     * @memberof AttributeDTO
     */
    histogramSeriesProperties?: HistogramSeriesAttributeDTO;
    /**
     * 
     * @type {IntAttributeDTO}
     * @memberof AttributeDTO
     */
    intProperties?: IntAttributeDTO;
    /**
     * 
     * @type {string}
     * @memberof AttributeDTO
     */
    name: string;
    /**
     * 
     * @type {StringAttributeDTO}
     * @memberof AttributeDTO
     */
    stringProperties?: StringAttributeDTO;
    /**
     * 
     * @type {StringSeriesAttributeDTO}
     * @memberof AttributeDTO
     */
    stringSeriesProperties?: StringSeriesAttributeDTO;
    /**
     * 
     * @type {StringSetAttributeDTO}
     * @memberof AttributeDTO
     */
    stringSetProperties?: StringSetAttributeDTO;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof AttributeDTO
     */
    type: AttributeTypeDTO;
}



/**
 * Check if a given object implements the AttributeDTO interface.
 */
export function instanceOfAttributeDTO(value: object): value is AttributeDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AttributeDTOFromJSON(json: any): AttributeDTO {
    return AttributeDTOFromJSONTyped(json, false);
}

export function AttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'boolProperties': json['boolProperties'] == null ? undefined : BoolAttributeDTOFromJSON(json['boolProperties']),
        'complexProperties': json['complexProperties'] == null ? undefined : ComplexAttributeDTOFromJSON(json['complexProperties']),
        'datetimeProperties': json['datetimeProperties'] == null ? undefined : DatetimeAttributeDTOFromJSON(json['datetimeProperties']),
        'evaluationSeriesProperties': json['evaluationSeriesProperties'] == null ? undefined : EvaluationSeriesAttributeDTOFromJSON(json['evaluationSeriesProperties']),
        'experimentStateProperties': json['experimentStateProperties'] == null ? undefined : ExperimentStateAttributeDTOFromJSON(json['experimentStateProperties']),
        'fileRefProperties': json['fileRefProperties'] == null ? undefined : FileRefAttributeDTOFromJSON(json['fileRefProperties']),
        'fileRefSeriesProperties': json['fileRefSeriesProperties'] == null ? undefined : FileRefSeriesAttributeDTOFromJSON(json['fileRefSeriesProperties']),
        'floatProperties': json['floatProperties'] == null ? undefined : FloatAttributeDTOFromJSON(json['floatProperties']),
        'floatSeriesProperties': json['floatSeriesProperties'] == null ? undefined : FloatSeriesAttributeDTOFromJSON(json['floatSeriesProperties']),
        'gitRefProperties': json['gitRefProperties'] == null ? undefined : GitInfoDTOFromJSON(json['gitRefProperties']),
        'histogramSeriesProperties': json['histogramSeriesProperties'] == null ? undefined : HistogramSeriesAttributeDTOFromJSON(json['histogramSeriesProperties']),
        'intProperties': json['intProperties'] == null ? undefined : IntAttributeDTOFromJSON(json['intProperties']),
        'name': json['name'],
        'stringProperties': json['stringProperties'] == null ? undefined : StringAttributeDTOFromJSON(json['stringProperties']),
        'stringSeriesProperties': json['stringSeriesProperties'] == null ? undefined : StringSeriesAttributeDTOFromJSON(json['stringSeriesProperties']),
        'stringSetProperties': json['stringSetProperties'] == null ? undefined : StringSetAttributeDTOFromJSON(json['stringSetProperties']),
        'type': AttributeTypeDTOFromJSON(json['type']),
    };
}

export function AttributeDTOToJSON(value?: AttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'boolProperties': BoolAttributeDTOToJSON(value['boolProperties']),
        'complexProperties': ComplexAttributeDTOToJSON(value['complexProperties']),
        'datetimeProperties': DatetimeAttributeDTOToJSON(value['datetimeProperties']),
        'evaluationSeriesProperties': EvaluationSeriesAttributeDTOToJSON(value['evaluationSeriesProperties']),
        'experimentStateProperties': ExperimentStateAttributeDTOToJSON(value['experimentStateProperties']),
        'fileRefProperties': FileRefAttributeDTOToJSON(value['fileRefProperties']),
        'fileRefSeriesProperties': FileRefSeriesAttributeDTOToJSON(value['fileRefSeriesProperties']),
        'floatProperties': FloatAttributeDTOToJSON(value['floatProperties']),
        'floatSeriesProperties': FloatSeriesAttributeDTOToJSON(value['floatSeriesProperties']),
        'gitRefProperties': GitInfoDTOToJSON(value['gitRefProperties']),
        'histogramSeriesProperties': HistogramSeriesAttributeDTOToJSON(value['histogramSeriesProperties']),
        'intProperties': IntAttributeDTOToJSON(value['intProperties']),
        'name': value['name'],
        'stringProperties': StringAttributeDTOToJSON(value['stringProperties']),
        'stringSeriesProperties': StringSeriesAttributeDTOToJSON(value['stringSeriesProperties']),
        'stringSetProperties': StringSetAttributeDTOToJSON(value['stringSetProperties']),
        'type': AttributeTypeDTOToJSON(value['type']),
    };
}

